import { getCart, getOrder } from '@/services/FramedCheckout/orderServices'
import { log } from '@/services/Log'
import type { ApplePayHandlerBuilderInput } from '../types'
import { withSessionCancelationHandling } from './withSessionCancelationHandling'

const rawHandlePaymentMethodSelected = ({
  session,
  onAbort,
  orderParser,
}: ApplePayHandlerBuilderInput) => async (
  event: ApplePayJS.ApplePayPaymentMethodSelectedEvent,
) => {
  log('Apple Pay onpaymentmethodselected: ', event)
  const cart = await getCart()
  if (!cart) {
    await onAbort()
    throw new Error('No cart found')
  }
  const order = await getOrder({ cart })
  const currentApplePayData = orderParser(order)
  session.completePaymentMethodSelection({
    newTotal: currentApplePayData.total,
    newLineItems: currentApplePayData.lineItems,
  })
}

export const handlePaymentMethodSelected = (
  withSessionCancelationHandling(rawHandlePaymentMethodSelected)
)

export default handlePaymentMethodSelected
